import IndexNavbar from "components/Navbars/IndexNavbar.js";
import Footer from "components/Footers/Footer.js";
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom'
import axios from 'axios';

function SavoirPlus() {


  return (
    <>
    <IndexNavbar fixed />

        <section className="bg-gradient-to-r from-blue-500 via-blue-700 to-blue-900 relative pt-16 items-center max-h-screen flex flex-col" id="index-cover" style={{ marginTop: "5rem", padding: "1rem" }} >
        <div className="text-center">
          <img
            id="imageSafetyGuide"
            alt="Safety Guide"
            src={require("assets/img/Standard1.png")}
            className="rounded-lg mx-auto w-full" // Adjust the width as needed
            style={{ maxWidth: "1000px" }}
          />
        </div>
          <div className="">
            <div className="container mx-auto overflow-y-auto">
                  <p className="text-white">
                  Pour les guides chirurgicaux et les gouttières, les matériaux que nous utilisons sont des résines photodurcissables à base de polymère certifié USP Class VI et conçues pour la fabrication additive de pièces de qualité médicale. Elles sont transparentes, rigides et biocompatibles pour des contacts de longue durée (plus de 30 jours).
                  </p>
            </div>
            <br></br>
            <div className="container mx-auto overflow-y-auto">
                <p className="text-white">
                Elles peuvent être employées pour la fabrication de dispositifs médicaux et de composants d'impression 3D nécessitant une imperméabilité, une haute résistance aux chocs et une compatibilité avec la stérilisation.
                </p>
            </div>
            <br></br>
            <div className="">
                <h2 className="text-xl font-semibold text-white">
                    NB:
                </h2>
                <p className="text-white ">
                Les utilisateurs doivent vérifier de manière indépendante si un matériau imprimé convient à leur application particulière et à l'usage auquel il est destiné.
                </p>
            </div>
            <br></br>
            <div className="bg-white bg-opacity-90 p-8 rounded-lg shadow-lg mb-12" style={{backgroundColor:"#ffffffcb", marginBottom:"8rem"}}>
                <h2 className="text-xl font-semibold text-blueGray-900 text-center">
                    Les matériaux que nous utilisons sont biocompatibles et certifiés.
                </h2>
            </div>
            
              <br></br>


          </div>
        </section>
        <Footer />

    </>
  );
}

export default SavoirPlus;
